import axios from 'axios';
import { API_RESULT_CD, CommonResult, createApiRequestUrl, OK } from '../Common';
import { API_EXCEPTION_MSG } from '../../Common';

const URL = createApiRequestUrl('master/messageDisplayMethod');

export interface MessageDisplayMethodInfo {
  functionId: string;
  apiState: string;
  messageId: string;
  messageDisplayMethodCode: string;
}
export interface MasterMessageDisplayMethodApiResponse {
  messageDisplayMethodList: Array<MessageDisplayMethodInfo>;
  result: CommonResult;
}

export interface MasterMessageDisplayMethodApiResponseErrorResponse {
  messageDisplayMethodList: Array<MessageDisplayMethodInfo>;
  result: CommonResult;
}

export async function masterMessageDisplayMethodApiGet(): Promise<MasterMessageDisplayMethodApiResponse> {
  try {
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = await axios.get<MasterMessageDisplayMethodApiResponse>(URL, {
      headers,
    });
    const data = response.data;
    const status = response.status;

    switch (status) {
      case OK.status:
        return data;
      default:
        throw response;
    }
  } catch (error) {
    // TODO: エラーハンドリング実装後
    return {
      messageDisplayMethodList: [],
      result: {
        jobDateTime: '',
        resultCd: '9999',
        resultMessageDtoList: [
          {
            resultMessageCd: API_RESULT_CD.ERROR,
            resultMessage: `${API_EXCEPTION_MSG}  エラー内容:[${error}]`,
          },
        ],
      },
    };
  }
}
